import MeasuredDeviationsMosaic from './MeasuredDeviationsMosaic';
export default MeasuredDeviationsMosaic;

//# sourceMappingURL=index.js.map